(function(angular, schoolwork12) {
	'use strict';

	angular.module(schoolwork12.app.bulkImport.name).directive('fileModel',
			[ '$parse', function($parse) {
				return {
					restrict : 'A',
					link : function(scope, element, attrs) {
						var model = $parse(attrs.fileModel);
						var modelSetter = model.assign;
						element.bind('change', function() {
							scope.$apply(function() {
								var file = element[0].files[0];
								modelSetter(scope, file);
								scope.bulkImportFileSelected();
							});
						});
						element.bind('click', function() {
							scope.$apply(function() {
								element[0].value = "";
							});
						});
						scope.$watch(attrs.fileModel, function(file) {
							if(file == null){
								element[0].value = "";
							}
						});
					}
				};
			} ]);

}(angular, schoolwork12));
